import { useTranslation } from "react-i18next";import React from 'react';
import { Card, CardContent } from '@/shared/components/ui/card';
import { cn } from '@/shared/utils';

export const WMSStatCard = ({
  title,
  value,
  icon: Icon,
  color = 'blue',
  subtitle,
  trend,
  className
}) => {const { t } = useTranslation("wms");
  const colorMap = {
    blue: 'bg-blue-500/10 text-blue-600',
    green: 'bg-green-500/10 text-green-600',
    yellow: 'bg-amber-500/10 text-amber-600',
    red: 'bg-red-500/10 text-red-600',
    purple: 'bg-purple-500/10 text-purple-600',
    indigo: 'bg-indigo-500/10 text-indigo-600'
  };

  const borderColorMap = {
    blue: 'border-l-blue-500',
    green: 'border-l-green-500',
    yellow: 'border-l-amber-500',
    red: 'border-l-red-500',
    purple: 'border-l-purple-500',
    indigo: 'border-l-indigo-500'
  };

  return (
    <Card className={cn(
      "card-elevated border-l-4 transition-all duration-200 hover:shadow-lg",
      borderColorMap[color],
      className
    )}>
      <CardContent className="p-5">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
              {title}
            </p>
            <p className="text-3xl font-bold mt-2 text-foreground font-['Space_Grotesk']">
              {value}
            </p>
            {subtitle &&
            <p className="text-sm text-muted-foreground mt-1">
                {subtitle}
              </p>
            }
            {trend &&
            <p className={cn(
              "text-sm mt-1 font-medium",
              trend.type === 'up' ? 'text-green-600' : 'text-red-600'
            )}>
                {trend.type === 'up' ? '↑' : '↓'} {trend.value}
              </p>
            }
          </div>
          {Icon &&
          <div className={cn(
            "flex h-12 w-12 items-center justify-center rounded-xl",
            colorMap[color]
          )}>
              <Icon className="h-6 w-6" />
            </div>
          }
        </div>
      </CardContent>
    </Card>);

};